import MenuAdmin from "./MenuAdmin";

export default MenuAdmin;